module.exports = __webpack_public_path__ + "media/images/admin2/Table__td__buttons__handle-99a317a25cccbcc7813765c758c1121a.svg";